import { Formik } from 'formik'

// Components

// Libs
import getformikConfig from './formikConfig'

export const defaultProps = {}

function SettingUserNamePopupContentFormik(props: any) {
  const { children }: any = props

  const formikConfig = getformikConfig(props)

  return <Formik {...formikConfig}>{() => children}</Formik>
}

SettingUserNamePopupContentFormik.defaultProps = defaultProps

export default SettingUserNamePopupContentFormik
